import React, { createContext, useReducer } from "react";
import { loadPaymentState, removePaymentState } from "../../../utils";

import Guest from "../../../models/Guest";
import { PaymentChannel } from "../../../models/Payment";
import ProductItemPayment from "../../../models/ProductItemPayment";

//import { AccessTimeOutlined } from "@material-ui/icons";
const [paymentData, error] = loadPaymentState();
const INITIAL_STATE = {
  items: [], //products to buy only
  showDiscountDialog: false,
  categories: [], //Global data for category
  productType: [{ name: "All", id: -1 }], //Global data for Product type
  discount: null,
  offer: null,
  pointasCash: null,
  currentTier: null,
  tierPrivileges: null, //Everytime we add or remove item we will check condition and apply available privilege
  showWallet: false,
  showWalkinInfoDialog: false,
  showPointasCash: false,
  showOffers: false,
  showPaymentConfirm: false,
  walkinInfo: null,
  viewItem: null,
  showClearAll: false,
  paymentChannels: [],
  clearItemDialog: { show: false, itemId: null, itemName: null },
  // getMemberType: (state) => {
  //   if (state.member) return "member";
  //   return "guest";
  // },
};

let initialState =
  error || paymentData === null ? { ...INITIAL_STATE } : { ...paymentData };

const reducer = (state, action) => {
  // console.log(
  //   `Call reducer: ${action.type} payload: ${JSON.stringify(action.payload)}`
  // );

  switch (action.type) {
    case "DO_NOTHING": {
      return state;
    }
    case "SET_STATE_FROM_STORAGE": {
      const data = action.payload;
      //Need to create item from data

      return { ...data };
    }
    case "TEST": {
      return state;
    }
    case "SHOW_OFFERS":
      return {
        ...state,
        showOffers: true,
      };
    case "HIDE_OFFERS":
      return {
        ...state,
        showOffers: false,
      };
    case "SHOW_WALLET":
      return {
        ...state,
        showWallet: true,
      };
    case "HIDE_WALLET":
      return {
        ...state,
        showWallet: false,
      };
    case "TOGGLE_WALLET":
      return {
        ...state,
        showWallet: !state.showWallet,
      };
    case "SHOW_CLEAR_ALL":
      return {
        ...state,
        showClearAll: true,
      };
    case "HIDE_CLEAR_ALL":
      return {
        ...state,
        showClearAll: false,
      };
    case "SHOW_DISCOUNT":
      return {
        ...state,
        showDiscountDialog: true,
      };
    case "HIDE_DISCOUNT":
      return {
        ...state,
        showDiscountDialog: false,
      };
    case "ADD_PRODUCT_AMOUNT":
      state.items[action.index].qty++;

      return {
        ...state,
        tierPrivileges: state.currentTier?.getPassConditionPrivileges(
          state.items
        ),
      };
    case "SET_PRODUCT_AMOUNT":
      state.items[action.index].qty = action.qty;

      return {
        ...state,
        tierPrivileges: state.currentTier?.getPassConditionPrivileges(
          state.items
        ),
      };
    case "CHANGE_PAYMENTLITE_AMOUNT_PAYMENT": {
      if (state.items.length > 0) {
        state.items[0].chargeAmount = Number(action.amount);
      }

      return {
        ...state,
      };
    }
    case "ADD_PRODUCT":
      const item = action.payload;
      const addQty = action.qty ?? 1;
      const cartList = state.items;
      const isfromAIRecommended = action.aiRecommended;

      let foundDupItem = false;

      const newCartList = cartList.map((cartItem) => {
        if (
          cartItem.productId === item.id &&
          cartItem.chargeAmount ===
            (action.customPrice ? action.customPrice : item.retail_price)
        ) {
          cartItem.increaseQty(addQty);
          foundDupItem = true;
        }
        return cartItem;
      });
      if (foundDupItem) {
        return {
          ...state,
          items: newCartList,
          tierPrivileges:
            state.currentTier?.getPassConditionPrivileges(newCartList),
        };
      } else {
        const itemData = new ProductItemPayment({
          itemRef: isfromAIRecommended ? "AI" : String(cartList.length + 1),
          itemName: item.name,
          categoryName: item.category.name,
          qty: addQty,
          retailPrice: Number(
            action.customPrice || action.customPrice === 0
              ? action.customPrice
              : item.retail_price
          ),
          categoryId: item.category.id,
          subCategoryId: item.sub_category?.id,
          subCategoryName: item.sub_category?.name,
          productId: item.id,
          imageUrl: item.image_url,
          skip_stock: item.skip_stock,
          code: item.code ?? null,
        });

        cartList.push(itemData);

        return {
          ...state,
          items: cartList,
          tierPrivileges:
            state.currentTier?.getPassConditionPrivileges(cartList),
        };
      }
    case "REMOVE_PRODUCT":
      // state.items = state.items.map((item) => {
      //   if (item.productId === action.payload) {
      //     item.decreaseQty(1);
      //   }
      //   return item;
      // });
      state.items[action.index].decreaseQty(1);
      state.items = state.items.filter((item) => item.qty > 0);
      return {
        ...state,
        items: state.items,
        tierPrivileges:
          state.currentTier?.getPassConditionPrivileges(state.items) ?? null,
      };
    case "REMOVE_PRODUCT_TO_ZERO":
      // state.items = state.items.map((item) => {
      //   if (item.productId === action.payload) {
      //     item.decreateAllQty();
      //   }
      //   return item;
      // });
      state.items[action.index].decreateAllQty(1);
      state.items = state.items.filter((item) => item.qty > 0);
      return {
        ...state,
        items: state.items,
        tierPrivileges:
          state.currentTier?.getPassConditionPrivileges(state.items) ?? null,
      };
    case "REMOVE_ALL":
      return {
        ...state,
        items: [],
      };
    case "SET_CATEGORIES": {
      state.categories.length = 0;
      //state.categories.push({ name: "All", id: "-1" });
      action.payload.forEach((data) => {
        state.categories.push({ name: data.name, id: data.id });
      });
      return {
        ...state,
        categories: state.categories,
      };
    }
    case "SET_VIEW_ITEM": {
      return {
        ...state,
        viewItem: action.payload,
      };
    }
    case "APPLY_DISCOUNT": {
      return {
        ...state,
        discount: action.payload.discount,
      };
    }
    case "SHOW_WALKIN": {
      return {
        ...state,
        showWalkinInfoDialog: true,
      };
    }
    case "HIDE_WALKIN": {
      return {
        ...state,
        showWalkinInfoDialog: false,
      };
    }
    case "SET_WALKIN": {
      return {
        ...state,
        walkinInfo: {
          ageRange: action.payload.ageRange,
          gender: action.payload.gender,
          hashtags: action.payload.hashtags,
        },
      };
    }
    case "SET_GUEST": {
      let result = {
        ...state,
        guest: new Guest({ ...action.payload }),
      };

      delete result.member;
      return result;
    }
    case "SET_MEMBER": {
      let result = {
        ...state,
        member: { ...action.payload },
      };
      delete result.guest;
      return result;
    }

    case "SET_MEMBER_TIER": {
      return {
        ...state,
        currentTier: action.payload,
      };
    }
    case "HIDE_POINT_AS_CASH": {
      return {
        ...state,
        showPointasCash: false,
      };
    }
    case "SHOW_POINT_AS_CASH": {
      return {
        ...state,
        showPointasCash: true,
      };
    }
    case "APPLY_POINT_AS_CASH": {
      return {
        ...state,
        pointasCash: action.payload.points,
      };
    }
    case "APPLY_OFFER": {
      return {
        ...state,
        offer: action.payload.offer,
      };
    }
    case "REMOVE_OFFER": {
      return {
        ...state,
        offer: null,
      };
    }
    case "SHOW_CLEAR_ITEM": {
      return {
        ...state,
        clearItemDialog: {
          show: true,
          itemId: action.payload.id,
          itemName: action.payload.name,
          index: action.payload.index,
        },
      };
    }
    case "HIDE_CLEAR_ITEM": {
      return {
        ...state,
        clearItemDialog: {
          show: false,
          itemId: null,
          itemName: null,
        },
      };
    }
    case "SET_DELIVERY_COST": {
      const deliveryCost = action.payload;
      return {
        ...state,
        deliveryCost: deliveryCost,
      };
    }
    case "SET_PAYMENT_CHANNEL": {
      const paymentChannel = new PaymentChannel({ ...action.payload });
      const paymentChannels = [];
      paymentChannels.push(paymentChannel);
      return { ...state, paymentChannels: paymentChannels };
    }
    case "REMOVE_PAYMENT_CHANNEL": {
      return { ...state, paymentChannels: [] };
    }
    case "SET_PAYMENT_CHANNELS": {
      const paymentChannels = [...action.payload];
      return { ...state, paymentChannels: paymentChannels };
    }
    case "SHOW_PAYMENT_CONFIRM": {
      return {
        ...state,
        showPaymentConfirm: true,
      };
    }
    case "HIDE_PAYMENT_CONFIRM": {
      return {
        ...state,
        showPaymentConfirm: false,
      };
    }
    case "RESET_STATE": {
      state.items.length = 0;
      state.paymentChannels.length = 0;
      removePaymentState();
      // if(state.member && state.member !== )
      return { ...INITIAL_STATE, items: [], paymentChannels: [] };
    }
    default: {
      throw new Error("ACTION TYPE IS NOT DEFINED");
    }
  }
};

// Create Context Object
export const PaymentCreateContext = createContext();

// Create a provider for components to consume and subscribe to changes
export const PaymentCreateContextProvider = (props) => {
  //const dataProvider = useDataProvider();
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PaymentCreateContext.Provider value={[state, dispatch]}>
      {props.children}
    </PaymentCreateContext.Provider>
  );
};
